import React, { Fragment } from "react";
import commonUtil from "../../../../../../utils/commonUtil";
import { eventType } from "../../../../../../utils/clientConstant";

const downloadIcon = (color) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='12'
    height='12'
    viewBox='0 0 12 12'
    fill='none'
  >
    <path
      d='M10.5 8.25V10.5H1.5V8.25H0V10.5C0 11.325 0.675 12 1.5 12H10.5C11.325 12 12 11.325 12 10.5V8.25H10.5ZM9.75 5.25L8.6925 4.1925L6.75 6.1275V0H5.25V6.1275L3.3075 4.1925L2.25 5.25L6 9L9.75 5.25Z'
      fill={color}
    />
  </svg>
);

const GiftListCategories = ({ handlePDFDownload, selectedTheme, lables, contentData, eventTypeValue, eventChecklistPdfUrl }) => {
  const color800 = selectedTheme?.color_800 ?? "#1C1C1C";

  let titleCss = "anadir-regalos-title";
  if(eventType.Bebe == eventTypeValue){
    titleCss += " anadir-regalos-title-width-100"
  }

  return (
    <Fragment>
      <div className="row 1 gift-list-categories-div">
        <div className="col-xs-12">
          <div className="anadir-below-div">
            <div>
              <div className={`${titleCss} pb-8`}>
                {contentData ? contentData.title : commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosregistrados.anadir.title.label"
                )}
              </div>
              <div className="anadir-regalos-subtitle">
                {contentData ? contentData.subTitle : commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosregistrados.anadir.subtitle.label"
                )}
              </div>
            </div>
            <div>
              <a
                href={eventChecklistPdfUrl}
                className="anadir-download-guide-btn"
                style={{ color: color800, borderColor: color800 }}
                download
                target="_blank"
                rel="noopener noreferrer"
              >
                {downloadIcon(color800)}
                {contentData ? contentData.buttonText : commonUtil.getLabel(
                  lables.EventAdminPage,
                  "adminpage.regalosregistrados.pdf.download.label"
                )}
              </a>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default GiftListCategories;
